<app-truck-sidebar
  [ngClass]="{ loading: isLoading }"
  [ngStyle]="isLoading ? { border: 'none', 'border-top-color': 'initial' } : {}"
></app-truck-sidebar>
<div class="truck-owner-details d-flex flex-column" style="width: 120vh; height: 93vh; padding: 10px;">
  <!-- Search Box -->
  <div class="mb-3">
    <input
      type="text"
      class="form-control"
      [(ngModel)]="searchQuery"
      (keyup.enter)="filterTrucks()"
      placeholder="Truck Number / Driver Name"
    />
  </div>

  <!-- MapLibre Map -->
  <div style="flex: 0 0 55vh; margin-bottom: 10px; position: relative;" id="map-container-wrapper">
    <div id="map-container" style="width: 100%; height: 100%; z-index: 1;"></div>
  </div>

  <!-- Truck List -->
  <div style="flex: 1; overflow-y: auto;">
    <mat-card class="trucks" style="max-height: 25vh; overflow-y: auto;">
      <div><strong>Total Trucks:</strong> {{ markerPositions.length }}</div>
      <mat-divider></mat-divider>
      <div class="shimmer-wrapper" *ngIf="isLoading">
  <div class="shimmer-item" *ngFor="let item of [1, 2, 3, 4, 5, 6]"></div>
</div>
      <div
        class="trucks_Available"
        *ngFor="let items of markerPositions; let i = index"
        [ngClass]="{
          selected: isSelectedTruck === items.truckNumber,
          highlighted: highlightedTruckNumber === items.truckNumber
        }"
      >
        <div (click)="selectTruck(items, false)">
          {{ i + 1 }}. {{ items.truckNumber }}
        </div>
      </div>
    </mat-card>
  </div>
</div>

<form action="">
  <div class="modal" id="myModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" *ngIf="truckStatus">
          <h4
            class="modal-title trip"
            *ngIf="arrayMarker?.truckStatus != 'null'"
          >
            {{ arrayMarker?.truckStatus.toUpperCase() }}
          </h4>
          <!-- <h4 class="modal-title trip" *ngIf="resArray?.truckStatus === 'null'">
            {{ "OFFLINE" }}
          </h4> -->
          <button
            type="button"
            class="close"
            (click)="closeModel()"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>

        <div class="modal-header" *ngIf="truckOfflineStatus">
          <h4 class="modal-title trip">
            {{ statusOffline }}
          </h4>
          <button
            type="button"
            class="close"
            (click)="closeModel()"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-header" *ngIf="intransit">
          <h4 class="modal-title trip">ON-TRIP</h4>
          <button
            type="button"
            class="close"
            (click)="closeModel()"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        
        <div class="modal-body name">
          <div class="row">
            <div class="col-sm-6">
              <b>Vehicle Number:</b>
              <div class="">{{ arrayMarker?.truckNumber }}</div>
            </div>
            <div class="col-sm-6">
              <b>Driver Name:</b>
              <div class="">
                {{ arrayMarker?.driverName }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <b>Trip Id/Status:</b>
              <div class="">{{ arrayMarker?.trip_id }} - {{ arrayMarker?.tripdetails?.trip_status }}</div>
            </div>
            <div class="col-sm-6">
              <b>Mobile Number:</b>
              <div class="">{{ arrayMarker?.mobile }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <b>Trip Start Date:</b>
              <div class="">
                {{ arrayMarker?.startdate | date : "dd-MM-yyyy" }}
              </div>
            </div>
            <div class="col-sm-6">
              <b>Last Updated:</b>
              <div class="">
                {{ arrayMarker?.updateDate | date : "dd-MM-yyyy, hh:mm a"}}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <b>Latitude:</b>
              <div class="">{{ arrayMarker?.location?.lat }}</div>
            </div>
            <div class="col-sm-6">
              <b>Longitute:</b>
              <div class="">{{ arrayMarker?.location?.lng }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12"><b>Location:</b> 
              <div>{{ arrayMarker?.address }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
